import {useRef, useEffect, useState} from 'react';
import noImageNoBackground from './images/no-image-no-bg.png';
import noImageWithBackground from './images/no-image-with_bg.png';
import './ImageWrapper.css';

function ImageWrapper({image, alt, display, width, height, errorWidth, errorHeight, errorPadding, backgroundColor, margin, padding, borderRadius, transition = true, loadDelay, noImageType, onLoad}) {
    const imageRef = useRef(null);
    const [isLoadingImage, setIsLoadingImage] = useState(true);
    const [imageLoaded, setImageLoaded] = useState(false);
    const [usingErrorImage, setUsingErrorImage] = useState(false);

    useEffect(() => {
        const element = imageRef.current;
        element.onload = () => {
            setTimeout(() => {
                setIsLoadingImage(false);
                setImageLoaded(true);
                if (onLoad) onLoad(true, image);
            }, loadDelay * 1000);
        };
        element.onerror = () => {
            setTimeout(() => {
                setIsLoadingImage(false);
                setImageLoaded(false);
                if (onLoad) onLoad(false, image);
            }, loadDelay * 1000);
        };
        element.src = image;
    }, []);

    useEffect(() => {
        const element = imageRef.current;
        if (element) {
            if (!isLoadingImage && !imageLoaded) {
                element.src = getNoImage();
                setUsingErrorImage(true);
            } else if (!isLoadingImage && imageLoaded) {
                if (!element.src.includes(getNoImage())) setUsingErrorImage(false);
            }
        }
    }, [isLoadingImage, imageLoaded]);

    useEffect(() => {
        const element = imageRef.current;
        const newImage = image;
        const oldImage = element.src;
        if (newImage !== oldImage) {
            setIsLoadingImage(true);
            setTimeout(() => {element.src = newImage}, loadDelay * 1000);
        }
    }, [image]);

    const getNoImage = () => {
        return noImageType === 'with-background' ? noImageWithBackground : noImageNoBackground;
    };

    const getSize = () => {
        if (usingErrorImage && (errorWidth || errorHeight)) return {width: errorWidth || 0, height: errorHeight || 0};
        else return {width: width, height: height};
    };

    const containerStyle = () => {
        const size = getSize();
        return {
            display: display,
            margin: margin || 'unset',
            padding: usingErrorImage && errorPadding ? errorPadding : 'unset',
            width: size.width || 30,
            height: size.height || 30
        };
    };

    const imageStyle = () => {
        const size = getSize();
        return {
            width: size.width || 30,
            height: size.height || 30,
            transform: `scale(${isLoadingImage ? 0 : 1})`,
            borderRadius: borderRadius || 0,
            transition: transition ? 'transform 0.2s ease' : 'unset',
            padding: padding ? padding : 0,
            background: backgroundColor || 'unset'
        };
    };

    return (
        <div className='image-wrapper-container' style={containerStyle()}>
            <img className='image-wrapper' ref={imageRef} alt={alt} style={imageStyle()} draggable={false}/>
        </div>
    );
}

export default ImageWrapper;